import React, { useState } from 'react';
import Modal from './Modal';

interface ModalData {
  title: string;
  imageSrc?: string;
  content: React.ReactNode;
  buttonText: string;
}

interface ModalSequenceProps {
  modalsData: ModalData[];
  onComplete: () => void;
}

const ModalSequence: React.FC<ModalSequenceProps> = ({ modalsData, onComplete }) => {
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    if (currentModalIndex < modalsData.length - 1) {
      // Move to the next modal
      setCurrentModalIndex(currentModalIndex + 1);
    } else {
      // All modals are finished
      setIsModalOpen(false);
      onComplete();  // Notify parent when the sequence completes
    }
  };

  const currentModal = modalsData[currentModalIndex];

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      title={currentModal.title}
      imageSrc={currentModal.imageSrc}
      content={currentModal.content}
      buttonText={currentModal.buttonText}
    />
  );
};

export default ModalSequence;
